//@flow
import type { AppState } from '../../core/types'
import PropTypes from 'prop-types'
import { compose, lifecycle, setPropTypes } from 'recompose'
import { connect } from 'react-redux'
import * as Selectors from './selectors'
import * as Actions from './actions'
import {
  isCommCompleted,
  isCommInProgress
} from '../../modules/communication/index'
import { RESOURCES } from './constants'
import RegisterCharityWizard from '../../ui/views/RegisterCharityWizard'
import { isSessionLoaded, getUserId } from '../session'
import withLoadingUntilProps from '../../core/withLoadingUntilProps'
import withTranslations from '../../core/withTranslations'
import withUserCharityData from './withUserCharityData'
import withBackAndNext from './withBackAndNext'

const propTypes = setPropTypes({
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  cancelText: PropTypes.string.isRequired,
  saveText: PropTypes.string.isRequired
})

const translations = withTranslations({
  pageTitle: 'registerCharity.title'
})

const mapStateToProps = (state: AppState) => {
  return {
    currentStep: Selectors.getWizardStep(state) || 1,
    isCreated: isCommCompleted(RESOURCES.CREATE_CHARITY, state),
    isCreating: isCommInProgress(RESOURCES.CREATE_CHARITY, state),
    isUpdated: isCommCompleted(RESOURCES.UPDATE_CHARITY, state),
    isUpdating: isCommInProgress(RESOURCES.UPDATE_CHARITY, state),
    isSessionLoaded: isSessionLoaded(state),
    userId: getUserId(state)
  }
}
const withWizardData = connect(mapStateToProps, Actions)

const restrictUser = lifecycle({
  verifyUserIsLoggedIn() {
    const { userId, history, location } = this.props
    if (!userId) {
      history.replace('/login', { returnUrl: location.pathname })
    }
  },
  verifyUserHasNoCharity() {
    const { isUpdating, charity, currentStep, history } = this.props
    // redirect to my charity if charity is published but allow step 4 for
    // confirmation page
    if (!isUpdating && charity && (!!charity.published && currentStep < 4)) {
      history.replace('/mycharity')
    }
  },
  componentDidMount() {
    this.verifyUserIsLoggedIn()
    this.verifyUserHasNoCharity()
  },
  componentDidUpdate() {
    this.verifyUserIsLoggedIn()
    this.verifyUserHasNoCharity()
  }
})

export const decorator = compose(
  withUserCharityData,
  withWizardData,
  withLoadingUntilProps('isSessionLoaded'),
  restrictUser,
  withBackAndNext,
  translations,
  propTypes
)

export default decorator(RegisterCharityWizard)



// WEBPACK FOOTER //
// ./src/services/register-charity/Wizard.js